import Raven from 'raven-js';
import FormattedJSXMessage from 'I18n/components/FormattedJSXMessage';
import FormattedPrice from './FormattedPrice';
import FormattedDateTime from 'I18n/components/FormattedDateTime';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { jsx as _jsx } from "react/jsx-runtime";
const getRecurringBillingFrequencyEnum = recurringBillingTerms => {
  if (!recurringBillingTerms) {
    return null;
  }
  const {
    intervalUnit,
    intervalLength
  } = recurringBillingTerms;
  if (intervalUnit === 'DAYS' && intervalLength === 1) {
    return 'DAYS';
  } else if (intervalUnit === 'MONTHS' && intervalLength === 1) {
    return 'MONTHS';
  } else if (intervalUnit === 'MONTHS' && intervalLength === 3) {
    return 'QUARTERS';
  } else if (intervalUnit === 'MONTHS' && intervalLength === 6) {
    return 'SIX_MONTHS';
  } else if (intervalUnit === 'YEARS' && intervalLength === 1) {
    return 'YEARS';
  } else {
    Raven.captureMessage('Unsupported recurring billing configuration', {
      level: 'info',
      extra: {
        recurringBillingTerms
      }
    });
    return null;
  }
};
const RecurringMessage = ({
  currencyCode,
  recurringSubtotals
}) => {
  if (recurringSubtotals.length > 1) {
    return /*#__PURE__*/_jsx(FormattedMessage, {
      message: "paymentLinkSelect.recurringMessageSubtext.generalMultipleRecurringPaymentsMessage"
    });
  }
  const recurringSubtotal = recurringSubtotals && recurringSubtotals[0];
  const {
    subtotal,
    recurringBillingTerms
  } = recurringSubtotal || {};
  const {
    numPayments,
    initialPayment
  } = recurringBillingTerms || {};

  // return early if any of the required fields are missing
  if (typeof subtotal !== 'number' || !initialPayment || !initialPayment.type) {
    return null;
  }
  const hasFixedBillingStartDate = initialPayment.type === 'FUTURE_START_DATE';
  const hasRelativeBillingStartDate = initialPayment.type === 'RELATIVE_START_DATE' && initialPayment.relativeDelay;
  const numSubsequentPayments = !numPayments || hasFixedBillingStartDate || hasRelativeBillingStartDate ? numPayments : numPayments - 1;
  if (numSubsequentPayments === 0) {
    return /*#__PURE__*/_jsx(FormattedMessage, {
      message: "paymentLinkSelect.recurringMessageSubtext.noFuturePayments"
    });
  }
  const messageKey = (() => {
    if (hasFixedBillingStartDate) {
      return 'paymentLinkSelect.recurringMessageSubtext.recurringSubtotalWithFixedStartDate_jsx';
    }
    if (hasRelativeBillingStartDate) {
      return `paymentLinkSelect.recurringMessageSubtext.recurringSubtotalWithRelativeStartDate.${initialPayment.relativeDelay.delayUnit}_jsx`;
    }
    if (numPayments === null || numPayments === undefined) {
      return 'paymentLinkSelect.recurringMessageSubtext.indefinitelyRecurringSubtotalMessage_jsx';
    }
    return 'paymentLinkSelect.recurringMessageSubtext.recurringSubtotalMessage_jsx';
  })();
  const formattedDate = /*#__PURE__*/_jsx(FormattedDateTime, {
    value: Number(initialPayment.futureStartDate),
    format: "L",
    type: "utc"
  });
  return /*#__PURE__*/_jsx(FormattedJSXMessage, {
    message: messageKey,
    options: {
      priceProps: {
        currencyCode,
        price: subtotal,
        frequency: getRecurringBillingFrequencyEnum(recurringBillingTerms)
      },
      delayLength: hasRelativeBillingStartDate && initialPayment.relativeDelay.delayLength,
      count: hasRelativeBillingStartDate ? initialPayment.relativeDelay.delayLength : numSubsequentPayments,
      formattedDate
    },
    elements: {
      FormattedPrice
    }
  });
};
export default RecurringMessage;